import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tutorial")({
  beforeLoad: () => {
    throw redirect({ to: "/help" });
  },
});
